export default __webpack_public_path__ + "static/media/email.e8ab175a.png";